import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const objections = ['This is NOT a random collection of swimming drills downloaded from different places.', 'This is NOT a theory-heavy manual you have to rewrite before it becomes useful at the pool.', 'This is NOT a lifeguard or rescue-training program.', 'And this is NOT generic material that leaves you wondering how to turn the information into an actual swimming lesson.'];
const steps = ['You open the system.', 'Choose the skill or level.', 'Select the appropriate lesson.', 'And walk onto the pool deck with a clear plan.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy" data-id="element-233" data-mp="13zy1mkbqik8n">
      <div className="max-w-5xl mx-auto" data-id="element-234" data-mp="13ywg1lx3efco">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center max-w-3xl mx-auto" data-id="element-235" data-mp="2jgy4gpi28q4g">
          <p className="text-aqua font-semibold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-236" data-mp="2bxtecxo0t9yu">
            One Complete System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-237" data-mp="2kvvoc2pqfcy9">
            The Complete Swim Teaching Library for Instructors Who Want Every Lesson
            Organized
          </h2>
          <h3 className="text-xl font-bold mb-3 text-gold-light" data-id="element-238" data-mp="1t60ld38ybor4">
            Swim Instructor Ready — A Complete 6-in-1 Teaching System
          </h3>
          <p className="text-base md:text-lg text-white/75 mb-12" data-id="element-239" data-mp="1x4q8hnjskkny">
            120 Ready-to-Teach Lessons · 6 Complete Volumes · 5 Premium Bonuses
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-240" data-mp="26y714o86ztq1">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-navy-dark/60 p-6 rounded-2xl border border-white/10" data-id="element-241" data-mp="19i08err0705z">
            {objections.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-242" data-mp="2qjj5oohkhs3u">
                <XIcon className="text-white/40 shrink-0 mt-1" size={18} data-id="element-243" data-mp="2qir7r70hziae" />
                <p className="text-white/70 text-sm" data-id="element-244" data-mp="2mj8osgs8lha7">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-ivory p-6 rounded-2xl border border-gold/50" data-id="element-245" data-mp="1ysmrnkjrthez">
            <div className="flex items-start gap-3 mb-5" data-id="element-246" data-mp="22w2nieo0ndqm">
              <CheckIcon className="text-aqua-dark shrink-0 mt-1" size={20} data-id="element-247" data-mp="3j76mdsfpvyl7" />
              <p className="text-navy font-medium text-base leading-relaxed" data-id="element-248" data-mp="3e9de8tuusuia">
                Swim Instructor Ready is a complete professional 6-in-1 teaching system
                designed to help you know what to teach, how to teach it, what to correct,
                and how to progress your swimmers.
              </p>
            </div>
            <ol className="space-y-2 border-t border-pearl-dark pt-4" data-id="element-249" data-mp="3ctiusree4zfn">
              {steps.map((step, index) => <li key={step} className="flex items-start gap-3 text-sm text-graphite" data-id="element-250" data-mp="3ht59745yglq1" data-mpi={index}>
                  <span className="text-gold-dark font-bold tabular-nums" data-id="element-251" data-mp="9c0zfjft1kw4">
                    0{index + 1}
                  </span>
                  <span data-id="element-252" data-mp="3vqtta9s77ou1">{step}</span>
                </li>)}
            </ol>
          </motion.div>
        </div>
      </div>
    </section>;
}